import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { NgSelectModule } from '@ng-select/ng-select';
import { FormlyModule } from '@ngx-formly/core';
import { FormlyBootstrapModule } from '@ngx-formly/bootstrap';
import { MonacoEditorModule } from 'ngx-monaco-editor-v2';

import { WorkflowBuilderComponent } from './components/workflow-builder/workflow-builder.component';
import { StateNodeComponent } from './components/state-node/state-node.component';
import { EventLabelComponent } from './components/event-label/event-label.component';
import { ConditionNodeComponent } from './components/condition-node/condition-node.component';
import { JsonPanelComponent } from './components/json-panel/json-panel.component';
import { InspectorComponent } from './components/inspector/inspector.component';
import { AddEventComponent } from './components/add-event/add-event.component';
import { ActionArgsFormComponent } from './components/action-args-form/action-args-form.component';
import { FullscreenJsonEditorComponent } from './components/fullscreen-json-editor/fullscreen-json-editor.component';
import { WorkflowConfigFormsModule } from '../workflow-config-forms.module';
import { NotificationActionEditorComponent } from './components/notification-action-editor/notification-action-editor.component';
import { VariableTokenSelectComponent } from './components/variable-token-select/variable-token-select.component';
import { SharedModule } from '../../shared/shared.module';

@NgModule({
  declarations: [
    WorkflowBuilderComponent,
    StateNodeComponent,
    EventLabelComponent,
    ConditionNodeComponent,
    JsonPanelComponent,
    InspectorComponent,
    AddEventComponent,
    ActionArgsFormComponent,
    NotificationActionEditorComponent,
    VariableTokenSelectComponent,
    FullscreenJsonEditorComponent,
  ],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    FormsModule,
    NgSelectModule,
    FormlyModule,
    FormlyBootstrapModule,
    MonacoEditorModule,
    WorkflowConfigFormsModule,
    SharedModule,
  ],
  exports: [WorkflowBuilderComponent, VariableTokenSelectComponent],
})
export class IremboWorkflowBuilderV2Module {}
